/**
 * Runs `worker` over `items` with at most `limit` in flight.
 * Checks `shouldStop` before starting each item, so Cancel stops new calls while in-flight ones finish.
 * ⚠️ The worker must catch its own errors.
 */
export async function runPool<T>(
  items: T[],
  limit: number,
  worker: (item: T) => Promise<void>,
  shouldStop: () => boolean,
): Promise<void> {
  let next = 0;
  const lanes = Array.from({ length: Math.min(limit, items.length) }, async () => {
    while (!shouldStop()) {
      const index = next++;
      if (index >= items.length) return;
      await worker(items[index]);
    }
  });
  await Promise.all(lanes);
}
